import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Menu16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M14 4.25H2V2.75H14V4.25Z' fill='currentColor' />
    <path d='M14 8.75H2V7.25H14V8.75Z' fill='currentColor' />
    <path d='M2 13.25H14V11.75H2V13.25Z' fill='currentColor' />
  </Svg>
);

Menu16.displayName = 'Menu16';
export default Menu16;
